(ns teamoesterreich.admin-mode.training.training-slot-user-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.selection.selection-table :as table]
            [teamoesterreich.admin-mode.modal.toe-info :as toe-modal]
            [teamoesterreich.admin-mode.data.trainingMember :as d-trainingMember]
            [teamoesterreich.admin-mode.data.training :as d-training]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.util.helper :as h]

            [reagent-material-ui.icons.close :refer [close]]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.check-box-two-tone :refer [check-box-two-tone]]

            [reagent-material-ui.icons.how-to-reg :refer [how-to-reg]]
            [reagent-material-ui.icons.airline-seat-recline-normal :refer [airline-seat-recline-normal]]
            [reagent-material-ui.icons.space-bar :refer [space-bar]]
            ))


(defn count-true [map_]
  (count (filter second map_)))


(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info {:fontSize "small"}]])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element[:span"-"]))))

(defn remove-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "löschen"
                            :onClick #(swap! !st assoc :show-delete cell-data)
                            }
           [delete-outline {:fontSize "small"}]])))))


(defn accepted-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `zugesagt` setzen"
                            :onClick #(swap! !st assoc :show-accept cell-data)
                            }
           [check {:fontSize "small"}]])))))

(defn declined-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `abgesagt` setzen"
                            :onClick #(swap! !st assoc :show-decline cell-data)
                            }
           [close {:fontSize "small"}]])))))

(defn participated-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `Im Einsatz` setzen"
                            :onClick #(swap! !st assoc :show-participated cell-data)
                            }
           [how-to-reg {:fontSize "small"}]])))))

(defn standby-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `Reserve` setzen"
                            :onClick #(swap! !st assoc :show-standby cell-data)
                            }
           [airline-seat-recline-normal {:fontSize "small"}]])))))

(defn absent-cell-renderer [!st]
  (let []
    (fn [js-parm]
      (let [{cell-data "cellData"} (js->clj js-parm)
            ]
        (r/as-element
          [mui/icon-button {:title "auf `Nicht gekommen` setzen"
                            :onClick #(swap! !st assoc :show-absent cell-data)
                            }
           [space-bar {:fontSize "small"}]])))))

(defn select-all [!st allIds]
  (let [!selected (r/cursor !st [:selected-multi])]
    [mui/icon-button
     {:title   "Alle auswählen"
      :onClick (fn []
                 (log/debug "count all " (count allIds))
                 (let [selUnSel (not (= (count (filter second @!selected)) (count allIds)))
                       res (into {} (map (fn [e] [e selUnSel]) allIds))]
                   (reset! !selected res)
                   ))}
     [check-box-two-tone]]
    ))


(defn select-renderer [!st ro?]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/checkbox
         {:onChange (fn [_ val] (swap! !st assoc-in [:selected-multi cell-data] val))
          :disabled ro?
          :checked (or (get-in @!st [:selected-multi cell-data] false))
          }
         ]))))

(defn inside-table [!st rows {:keys [allow-delete? ro? show-alarm-answer?]}]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight 50
          :height (- height 250)
          :rowCount (count rows)
          :rowGetter (fn [i]
                       ;(println (str "rowGet " (aget i "index")))
                       (clj->js (nth rows (aget i "index"))))
          :rowClassName (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy @!sort
          :sortDirection (if @!reverse "DESC" "ASC")
          :rowHeight 45
          :width width
          :headerClassName "headerColumn"
          :className "TestTable2"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse  rows)

         [:> rv/Column
          {:label (r/as-element [mui/checkbox {:clickable "false"}])
           :dataKey (name :user-tomId)
           :className "bordered exampleColumn"
           :cellRenderer (select-renderer !st ro?)
           :width 70} [:a {:href ""}]]

         [:> rv/Column
          {:label     "TomId"
           :dataKey   "user-tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     70}]
         [:> rv/Column
          {:label     "Vorname"
           :dataKey   "user-firstName"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]
         [:> rv/Column
          {:label     "Nachname"
           :dataKey   "user-lastName"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Geburtstag"
           :dataKey   "user-birthday"
           :className "bordered exampleColumn"
           :cellRenderer date-renderer
           :width     170}]
         [:> rv/Column
          {:label     "Email"
           :dataKey   "user-email"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Handy"
           :dataKey   "user-phoneNumber"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Termin"
           :dataKey   "slot-name"
           :className "bordered exampleColumn"
           :width     170}]

         (when show-alarm-answer?
           [:> rv/Column
            {:label     "Antwort"
             :dataKey   "response-time"
             :className "bordered exampleColumn"
             :cellRenderer date-time-renderer
             :width     100}])


         [:> rv/Column
          {:label        (r/as-element [info])
           :dataKey      "user-tomId"
           :className    "bordered exampleColumn"
           :cellRenderer info-cell-renderer
           :width        70} ]

         (when (and allow-delete? (not ro?))
           [:> rv/Column
            {:label        (r/as-element [delete-outline])
             :dataKey      "member-uuid"
             :className    "bordered exampleColumn"
             :cellRenderer (remove-cell-renderer !st)
             :width        70} ])




         ]))))





(defn filter-fn [rows search ]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split  search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn get-sort-filter-rows [rows sort_ reverse_ filter_ filterSlots]
  (js/console.log "get-sort-filter-rows = "  rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (filter (fn [e] (not (false? (get filterSlots (or (:slot-uuid e) "")))) ) rows)
        rows (filter-fn rows filter_)
        rows (sort-by (keyword (if sort_ sort_ :user-lastName)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))

(defn slot-checkbox [slot !filter-slots update-list-fn]
  [mui/form-control-label {:label (str (:trainingSlot-name slot)) :value "dst" :placement "start"
                           :fullWidth true
                           :control (r/as-element [mui/checkbox {:checked (if (false? (get @!filter-slots (:trainingSlot-uuid slot))) false true)
                                                                 :onChange (fn [_ val] (swap! !filter-slots assoc (:trainingSlot-uuid slot) val) (update-list-fn))
                                                                 }])}])


(defn table-column [!st rows]
  (let [
        rows (get-sort-filter-rows rows (:sort @!st) (:reverse @!st) (:search @!st) (:filter-slots @!st))
        cnt-rows (count rows)]

    (if (> cnt-rows 0)
      [(table/table !st rows)]
      [:h3 "Keine Ergebnisse gefunden!"])
    ))

(defn selected-actions [!training !st]
  (let [!show-invited (r/cursor !st [:show-invited-multi])
        !show-absent (r/cursor !st [:show-absent-multi])
        !show-participated (r/cursor !st [:show-participated-multi])
        !show-unknown (r/cursor !st [:show-unknown-multi])
        !show-no-slot (r/cursor !st [:show-no-slot-multi])
        !show-to-slot (r/cursor !st [:show-no-slot-multi])
        !show-remove (r/cursor !st [:show-remove-multi])
        !st-selected (r/cursor !st [:selected-multi])
        !st-selection-slot (r/cursor !st [:selected-slot])
        !st-selection-action (r/cursor !st [:selected-action])
        event-uuid (:trainingEvent-uuid @!training)
        ]
    [:div

     [are-you-sure-modal/are-you-sure-modal !show-absent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Nicht erschienen` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "absent" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-participated (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Teilgenommen` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "participated" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-unknown (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Zusage` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "unknown" @!st-selection-slot #(d-training/training-update)))]



     [are-you-sure-modal/are-you-sure-modal !show-remove (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich aus der Veranstaltung entfernen?") "Entfernen"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "remove" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-invited (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Nicht Zugesagt` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "invited" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-no-slot (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Ohne Termin` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "standby" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-absent (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich auf `Nicht gekommen` setzen?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "absent" @!st-selection-slot #(d-training/training-update)))]

     [are-you-sure-modal/are-you-sure-modal !show-to-slot (str "Willst du diese ausgewählten " (count-true @!st-selected) " Teilnehmer  wirklich den Termin verschieben?") "Ok"
      (fn []  (d-trainingMember/>members-set event-uuid @!st-selected "to-slot" @!st-selection-slot #(d-training/training-update)))]

     [mui/select
      {:style {:width "300px"}
       :defaultValue "-"
       :onChange (fn [e]
                   (let [[action uuid] (clojure.string/split (h/event-value e) #"#")]
                     (log/debug " st-selection-action" action uuid)
                     (reset! !st-selection-action action)
                     (reset! !st-selection-slot (str uuid))))
       }
      [mui/menu-item {:value "-" } (str (count-true @!st-selected) " Auswahl")]

      [mui/menu-item {:value "unknown" } "-> Zusage"]
      [mui/menu-item {:value "participated" } "-> Teilgenommen"]
      [mui/menu-item {:value "absent_" } "-> Nicht erschienen"]

      (for [slot (sort-by :trainingSlot-name (filter #(not (false? (:trainingSlot-active %))) (:trainingEvent-slot @!training)))]
        ^{:key (str "slot-select-" (:trainingSlot-uuid slot))}
        [mui/menu-item {:value (str "to-slot#" (:trainingSlot-uuid slot))} (str "-> Termin: `" (:trainingSlot-name slot) "`")]
        )
      [mui/menu-item {:value "no-slot" } "-> Ohne Termin"]
      [mui/menu-item {:value "invited" } "-> Zusage zurücknehmen"]
      [mui/menu-item {:value "remove" } "-> Entfernen"]

      ]
     [mui/button {:disabled (if (or (nil? @!st-selection-action) (empty? @!st-selected) (= @!st-selection-action "-")) true false)
                  :onClick (fn []
                             (log/debug "übernehmen clicked " @!st-selection-action @!st-selected)
                             (case @!st-selection-action
                               "unknown" (reset! !show-unknown true)
                               "participated" (reset! !show-participated true)
                               "absent_" (reset! !show-absent true)
                               "invited" (reset! !show-invited true)
                               "no-slot" (reset! !show-no-slot true)
                               "absent" (reset! !show-absent true)
                               "remove" (reset! !show-remove true)
                               "to-slot" (reset! !show-to-slot true)
                               )
                             )} "übernehmen"]
     ]
    ))


(defn get-table [!st rows table-set]
  (fn [] [:> rv/AutoSizer
          {:style { :height "100%" :minHeight "400px"}
           :sort (str "rerender !st" @!st)}
          (inside-table !st rows table-set)]))

(defn get-it [member response-filter missionState-filter {:keys [ro? allow-accept? allow-decline?] :as table-set}]
  (let [!st (r/atom {:sort :user-lastName :reverse true :search "" :show-delete false :manipulate-tomId nil :show-mail false})
        !training (r/cursor vstate/app-state [:selected-training])
        slots-map (reduce (fn [c v] (assoc c (:trainingSlot-uuid v) v)) {} (:trainingEvent-slot @!training))
        user (into {} (map (fn [m] [(:trainingSlotMember-uuid m)
                                    (assoc (:trainingSlotMember-user m)
                                      :slot-uuid (:trainingSlotMember-slotUuid m)
                                      :slot-name (get-in slots-map [(:trainingSlotMember-slotUuid m) :trainingSlot-name])
                                      :member-uuid (:trainingSlotMember-uuid m)
                                      :response (:trainingSlotMember-responseState m)
                                      :response-time (:trainingSlotMember-responseTime m)
                                      :mission (:trainingSlotMember-state m)
                                      )] )
                           (filter (fn [e]
                                     (log/debug "filter " e "-" (:trainingSlotMember-responseState e) " - " (:trainingSlotMember-state e))
                                     (and
                                       (if response-filter (= (or (:trainingSlotMember-responseState e) "undefined")  response-filter) true)
                                       (if missionState-filter (= (or (:trainingSlotMember-state e) "undefined")  missionState-filter) true)
                                       )) member)))
        get-name-fn (fn [uuid] (if uuid (str (get-in user [uuid :user-tomId]) ") " (get-in user [uuid :user-firstName]) " " (get-in user [uuid :user-lastName]) ) ""))
        ]
    (fn []
      (let [!map-userPopup (r/cursor vstate/app-state [:toe-map :activeUserPopup])
            !training-detail-loaded? (r/cursor vstate/app-state [:trainingEvent-detail-loaded])
            !show-delete (r/cursor !st [:show-delete])
            !filter-slots (r/cursor !st [:filter-slots])
            !show-accept (r/cursor !st [:show-accept])
            !show-decline (r/cursor !st [:show-decline])
            !show-participated (r/cursor !st [:show-participated])
            !show-absent (r/cursor !st [:show-absent])
            !show-standby (r/cursor !st [:show-standby])
            !show-mail (r/cursor !st [:show-mail])
            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            !search (r/cursor !st [:search])
            !waiting? (r/cursor !st [:waiting])
            rows (get-sort-filter-rows user @!sort @!reverse @!search @!filter-slots)]
        (log/debug "training ROWS !!!!!!!!!!!!!!!!!!!!!!"  (count rows)  allow-accept?  allow-decline?)
        [mui/grid
         {:container true
          :direction "row"
          :alignItems "stretch"
          :justify "flex-start"
          :style {:height "calc(100% - 64px)" :minHeight "600px"}
          }

         [toe-modal/get-modal !map-userPopup]
         [are-you-sure-modal/are-you-sure-modal !show-delete (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-delete) " << wirklich aus dem Einsatz entfernen?") "Entfernen"
          (fn []
            (log/debug "entfernen " @!show-delete)
            (d-trainingMember/>member-drop @!show-delete #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-accept (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-accept) " << wirklich auf `zugesagt` setzen?") "Zusagen"
          (fn []
            (d-trainingMember/>member-save @!show-accept {:trainingSlotMember-responseState "accepted"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-decline (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-decline) " << wirklich auf `abgesagt` setzen?") "Absagen"
          (fn []
            (d-trainingMember/>member-save @!show-decline {:trainingSlotMember-responseState "declined"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-participated (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-participated) " << wirklich auf `Im Einsatz` setzen?") "Im Einsatz"
          (fn []
            (d-trainingMember/>member-save @!show-participated {:trainingSlotMember-state "participated"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-absent (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-absent) " << wirklich auf `Nicht gekommen` setzen?") "Nicht gekommen"
          (fn []
            (d-trainingMember/>member-save @!show-absent {:trainingSlotMember-state "absent"} #(d-training/training-update))
            )]
         [are-you-sure-modal/are-you-sure-modal !show-standby (str "Willst du diesen Teilnehmer >> " (get-name-fn @!show-standby) " << wirklich auf `Reserve` setzen?") "Reserve"
          (fn []
            (d-trainingMember/>member-save @!show-standby {:trainingSlotMember-state "standby"} #(d-training/training-update))
            )]

         [are-you-sure-modal/are-you-sure-modal !show-mail (str "Willst allen Personen in dieser Liste (" (count user) ") ein Email senden?") "senden"
          (fn [] (log/debug "email " (count user) ))]

         [mui/grid
          {:item true
           :xs 12}
          [ws-event-sync-component/ws-event-reload !training-detail-loaded? :training-event (:trainingEvent-uuid @!training)]
          ]

         [mui/grid
          {:item true :xs 12 :style {:textAlign "left"} }
          [mui/card-content
           [mui/grid
            {:container true :fullWidth true :direction "row" :alignItems "stretch" :justify "flex-start" :style { } }
            [mui/grid {:item true :lg 2 :md 3 :xs 4 :style {:textAlign "left"} }
             [mui/form-control-label {:label "Ohne Termin" :value "dst" :placement "start" :fullWidth true
                                      :control (r/as-element [mui/checkbox {:checked (if (false? (get @!filter-slots "")) false true)
                                                                            :onChange (fn [_ val] (swap! !filter-slots assoc "" val) (d-training/training-update))
                                                                            }])}]]

            (for [slot (sort-by :trainingSlot-name (filter #(not (false? (:trainingSlot-active %))) (:trainingEvent-slot @!training)))]
              ^{:key (str "slot-form-" (:trainingSlot-uuid slot))}
              [mui/grid {:item true :lg 2 :md 3 :xs 4 :style {:textAlign "left"} }
               [slot-checkbox slot !filter-slots #(d-training/training-update)]
               ]
              )]
           ]
          ]



         [mui/grid
          {:item true
           :md 6
           :xs 6
           :style {:textAlign "left"} }
          (when-not ro?
            [selected-actions !training !st])
          ]


         [mui/grid
          {:item true
           :md 3
           :xs 3
           :style {:textAlign "left"} }
          [mui/text-field
           {:default-value (str @!search)
            :placeholder "Suche in Liste ..."
            :style {:width "250px" :display "inline-block"}
            :onChange   (h/wait-do !waiting? #(reset! !search %))
            :multiline   false}]
          (log/debug "Search " @!search)
          (when false; (> (count @!search) 0)
            [mui/button {:variant "outlined"
                         :startIcon (r/as-element [close])
                         :onClick  (h/wait-do !waiting? (fn [_] (reset! !search "")))
                         :style {:margin-left "5px" :margin-right "25px"}} ""])
          ]
         [mui/grid
          {:item true
           :md 3
           :xs 3
           :style {:textAlign "right"} }
          [mui/button {:variant "outlined"
                       :startIcon (r/as-element [cloud-download])
                       :onClick #(d-trainingMember/open-csv (:trainingEvent-uuid @!training) response-filter missionState-filter @!filter-slots)
                       } "Csv Export"]
          ]

         [mui/grid
          {:item true
           :lg 12
           :xs 12
           :style {:textAlign "left"} }

          [(get-table !st rows table-set)]
          ]

         ]
        )
      )))

























